// internal
import { number } from './methods/number';
import { integer } from './methods/integer';
var random = {
  number: number,
  integer: integer
};
export { random };